import { axiosLander } from '@/shared/plugins/axiosLander';
import {
  landerBotErrorMessage,
  landerBotErrorSign,
  landerMessageDuration,
  landerSuccessSign,
  landerVersion,
} from '@/shared/constants/lander';
import emitter from '@/shared/services/emitter';
import { useLocalStorage } from '@/shared/composition/useLocalStorage';

interface ILeadParams {
  partner?: string | number;
  phone: string;
  name: string;
  lastName: string;
  secondName?: string;
  email: string;
  comments?: string;
  birthdate?: string | null;
  gender?: string | null;
  mergelead?: string;
  // eslint-disable-next-line camelcase
  is_contact_verified?: string | null;
}

const PARAMS = {
  'r': 'land/index',
  'unit': 'synergy',
  'type': 'sy_f',
  'ignore-thanksall': '1',
};

export const MERGE_LEAD_KEY = 'mergelead';

export const getMergeLead = (mergeLeadPrefix = 'SF') => {
  /* eslint-disable-next-line */
  const randomId = Math.random().toString(36).substr(2, 9);
  const time = Math.round(new Date().getTime() / 1000);
  return `${mergeLeadPrefix}_${randomId}${time}`;
};

export const sendLeadToBitrix = async (
  { params, payload }: { params: Record<string, string>; payload: Partial<ILeadParams> },
  withError = true,
  mergeLeadPrefix?: string,
) => {
  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    // @ts-ignore
    formData.append(key, payload[key]);
  });

  if (landerVersion && !formData.has('version')) {
    formData.append('version', landerVersion);
  }

  formData.append('personalDataAgree', 'on');

  if (!formData.has(MERGE_LEAD_KEY)) {
    formData.append(MERGE_LEAD_KEY, getMergeLead(mergeLeadPrefix));
  }
  const urlLocation = new URL(document.location.href);
  urlLocation.hash = '';

  if (params.utm_campaign) {
    urlLocation.searchParams.set('utm_campaign', params.utm_campaign);
  }

  if (params.utm_source) {
    urlLocation.searchParams.set('utm_source', params.utm_source);
  }

  if (formData.get(MERGE_LEAD_KEY)?.toString() === 'undefined') {
    formData.delete(MERGE_LEAD_KEY);
  }

  formData.append('url_location', urlLocation.toString());
  formData.append('entry_point', document.location.host);
  const whiteListSecretKey = useLocalStorage('white_list_secret_key', undefined);

  const { data } = await axiosLander.post('lander.php', formData, {
    params: {
      ...PARAMS,
      ...params,
      white_list_secret_key: whiteListSecretKey.value,
    },
  });

  if (String(data).toLowerCase()
    .includes(landerBotErrorSign)) {
    withError &&
      emitter.emit('createToast', {
        message: landerBotErrorMessage,
        color: 'error',
        timer: landerMessageDuration,
      });

    return false;
  }

  if (!data.includes(landerSuccessSign)) {
    withError &&
      emitter.emit('createToast', {
        message: data,
        color: 'error',
        timer: landerMessageDuration,
      });

    return false;
  }

  return true;
};
